import {
  Component,
  Input,
  OnInit,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { TabContent } from '../../../dto/util/tabs-dto';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent<TComponent extends object> implements OnInit {
  // Restricción añadida aquí
  @Input() tabs: TabContent<TComponent>[] = [];
  activeTabId: string | null = null;
  isActive = true;

  @ViewChild('tabContent', { read: ViewContainerRef })
  tabContent!: ViewContainerRef;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit(): void {
    if (this.tabs.length > 0) {
      this.activeTabId = this.tabs[0].id;
      this.loadTabContent(this.activeTabId);
    }
  }

  setActiveTab(tabId: string): void {
    this.activeTabId = tabId;
    this.loadTabContent(tabId);
  }

  isActiveTab(tabId: string): boolean {
    return this.activeTabId === tabId;
  }

  private loadTabContent(tabId: string): void {
    const tab = this.tabs.find(t => t.id === tabId);
    if (tab && tab.componentInputs) {
      const componentFactory =
        this.componentFactoryResolver.resolveComponentFactory(tab.component);
      const viewContainerRef = this.tabContent;
      viewContainerRef.clear();
      const componentRef = viewContainerRef.createComponent(componentFactory);
      Object.assign(componentRef.instance, tab.componentInputs); // Esto ahora debería funcionar sin errores
    }
  }

  // Método para eliminar la pestaña activa
  removeActiveTab(): void {
    if (this.activeTabId) {
      // Encuentra el índice de la pestaña activa
      const index = this.tabs.findIndex(tab => tab.id === this.activeTabId);
      if (index !== -1) {
        // Elimina la pestaña de la lista
        this.tabs.splice(index, 1);
        // Actualiza la pestaña activa
        this.activeTabId = this.tabs.length > 0 ? this.tabs[0].id : null;
      }
    }
  }
}
